export default __webpack_public_path__ + "static/media/home-bg.43e1925c.png";